import { Injectable } from "@angular/core";
import { ChatEndPoints, ConversationsSettingsModel, EncryptStorageEvent, logger, OrganizationModel } from "../..";
import { Events } from "ionic-angular";
import { ConversationsSettingsEvent } from "../../models/chat/conversations-settings-model";
var ConversationsSettingProvider = /** @class */ (function () {
    function ConversationsSettingProvider(_chatEndPoints, _model, _organizationModel, _events) {
        this._chatEndPoints = _chatEndPoints;
        this._model = _model;
        this._organizationModel = _organizationModel;
        this._events = _events;
        this._ready = false;
        this.bind();
    }
    ConversationsSettingProvider.prototype.bind = function () {
        var _this = this;
        this._events.subscribe(EncryptStorageEvent.SECRET_PASSPHRASE_CHANGED, function (res) {
            _this._model.clear(false, true);
            _this._model.load();
        });
        this._events.subscribe(this._organizationModel.event.URI_CHANGED, function () {
            _this._model.clear(false, true);
        });
        this._events.subscribe(ConversationsSettingsEvent.LOADED, function () {
            _this.load(_this._organizationModel.uri);
            _this._ready = true;
            _this._events.publish(ConversationsSettingProviderEvent.READY);
        });
    };
    Object.defineProperty(ConversationsSettingProvider.prototype, "model", {
        get: function () {
            return this._model;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConversationsSettingProvider.prototype, "ready", {
        get: function () {
            return this._ready;
        },
        enumerable: true,
        configurable: true
    });
    ConversationsSettingProvider.prototype.load = function (uri) {
        var _this = this;
        this._chatEndPoints.chatSetting(uri)
            .then(function (res) {
            _this._model.setLiveSupportOnline(res.liveSupportOnline);
            if (!(_this._model.liveSupportOnline == false && _this._model.liveSupportProvided == true)) {
                _this._model.setLiveSupportProvided(false);
            }
            _this._model.setWelcomeTitle(res.welcomeTitle);
            _this._model.setWelcomeDescription(res.welcomeDescription);
            _this._model.setShowWelcomeLogo(res.showWelcomeLogo);
            _this._model.setWelcomeLogoStyle(res.welcomeLogoStyle);
            _this._model.setWelcomeLogoUrl(res.welcomeLogoUrl);
            _this._model.setUserIds(res.userIds);
            _this._model.setUserTeamIds(res.userTeamIds);
            _this._model.setNotWorkingHoursGreetingMessage(res.offlineGreetingMessage);
            _this._model.setNotWorkingHoursMessage(res.simpleBotOfflineAnswer);
            _this._ready = true;
            _this._events.publish(ConversationsSettingProviderEvent.READY);
        }).catch(function (err) { return logger.info(err); });
    };
    ConversationsSettingProvider.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    ConversationsSettingProvider.ctorParameters = function () { return [
        { type: ChatEndPoints, },
        { type: ConversationsSettingsModel, },
        { type: OrganizationModel, },
        { type: Events, },
    ]; };
    return ConversationsSettingProvider;
}());
export { ConversationsSettingProvider };
export var ConversationsSettingProviderEvent;
(function (ConversationsSettingProviderEvent) {
    ConversationsSettingProviderEvent["READY"] = "conversation-setting-provider:ready";
})(ConversationsSettingProviderEvent || (ConversationsSettingProviderEvent = {}));
//# sourceMappingURL=conversations-setting-provider.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/providers/chat/conversations-setting-provider.js
// module id = 357
// module chunks = 14